import httpCommon from "./http-common";

// Get all document templates
const getDocumentTemplates = (businessId?: number) => {
  const params = businessId ? `?businessId=${businessId}` : '';
  return httpCommon.get(`/v1/get/documentTemplate${params}`);
};

// Create new document template
const createDocumentTemplate = (data: any) => {
  return httpCommon.post("/v1/add/documentTemplate", data);
};

// Update document template
const updateDocumentTemplate = (id: number, data: any) => {
  return httpCommon.put(`/v1/update/documentTemplate/${id}`, data);
};

// Delete document template
const deleteDocumentTemplate = (id: number) => {
  return httpCommon.delete(`/v1/delete/documentTemplate/${id}`);
};

// Get document template by ID
const getDocumentTemplateById = (id: number) => {
  return httpCommon.get(`/v1/get/documentTemplate/${id}`);
};

// Get templates by document type
const getTemplatesByDocumentType = (documentTypeId: number) => {
  return httpCommon.get(`/v1/get/documentTemplate/type/${documentTypeId}`);
};

const DocumentTemplatesService = {
  getDocumentTemplates,
  createDocumentTemplate,
  updateDocumentTemplate,
  deleteDocumentTemplate,
  getDocumentTemplateById,
  getTemplatesByDocumentType,
};

export default DocumentTemplatesService; 